module.exports = __webpack_public_path__ + "static/media/plus-black-o.9aeb41ca.svg";